import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";
import { SearchResult } from "../store/search";
import { get } from "../common/dataFetch";

export const search = (query: string) => get<SearchResult[]>(WebControllers.Search, WebActionNames.Search, { query });